import ValidateDefaults from 'validation/ValidateDefaults';

export default class ValidateConfirm extends ValidateDefaults {
    constructor(obj) {
        super(obj);
        this.secondFieldName = obj.options[0];
        this.secondFieldValue = null;
        this.message = obj.message ? obj.message : ' should match ' + this.secondFieldName;

        this.on = ['blur'];
    }

    getSecondFieldName() {
        return this.secondFieldName;
    }

    setSecondFieldValue(value) {
        this.secondFieldValue = value;
    }

    validate(str) {
        return str === this.secondFieldValue;
    }
}
